import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { Subject} from 'rxjs';
import {MatAccordion, MatExpansionPanel} from '@angular/material/expansion';
import {LeadingOfferInfo} from '../../../model/proposal/leading-offer-info';
import {QuestionOptions} from '../../../constants/question-options';

@Component({
    selector: 'app-leading-offer-tab',
    templateUrl: './leading-offer-tab.component.html',
    styleUrls: ['./leading-offer-tab.component.scss', '../../../../styles/create-something.scss'],
    standalone: false
})

export class LeadingOfferTabComponent implements OnDestroy {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;
  @Input() leadingOfferInfo: LeadingOfferInfo;

  // userId$ = this.store.select(selectUserId);

  allExpandState: boolean = false;


  protected destroy$ = new Subject<void>();
  QuestionOptions = QuestionOptions;

  constructor(private readonly cd: ChangeDetectorRef) {
  }


  @Input() set allDetailsOpen(value: boolean) {
    if (value) {
      this.accordion?.openAll();
    } else {
      this.accordion?.closeAll();
    }
    this.allExpandState = value;
  }

  clickButton($event: any): void {
    if (!this.accordion) return;
    if ($event) {
      this.accordion.openAll();
    } else {
      this.accordion.closeAll();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.clickButton(this.allExpandState));
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
